<template>
  <div id="app">
    <!-- <div class="title" style>查勘管理</div> -->
    <div class="app-main">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive"/>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"/>
    </div>
  </div>
</template>

<script>
import store from '@/store/index'

import Addr from './utils/getAPI'
import axios from 'axios'

import { Swiper, Slide } from 'vue-swiper-component'
export default {
  name: 'App',

  data() {
    return {
      
    }
  },
  created() {},
  methods: {
    
  },
  computed: {},
  watch: {
    
  },
  created: function() {
    console.log("App created");
  },
  components: {}
}
</script>

<style lang="scss" scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* max-width: 640px; */
  width: 100%;

  .title {
    // background-image: linear-gradient(45deg,#3a2772 30%,#190b2e 75%);
    //linear-gradient(20deg,rgba(88, 30, 182, 0.9) 20%,rgba(34, 98, 194, 0.9) 50%);
    // background-image:linear-gradient(
    //   45deg,
    //   #0f87e2,
    //   #6149f6
    // );
    position: absolute;
    top: 0px;
    left: 0px;
    z-index: 99999;
    width: 100%;
    background-image: linear-gradient(45deg, #0f87e2, #6149f6);

    color: white;
    text-align: center;
    padding-top: 7px;
    padding-bottom: 7px;
    font-size: 19px;
    font-weight: 550;
    opacity: 0.9;
  }

  .app-main {
    position: absolute;
    // top: 38.8px;
    top: 0px;
    left:0px;
    width: 100%;
    background-color: rgba(191,185,185,0.2);
    height:calc(100vh - 41px)
  }
}
.mint-tabbar > .mint-tab-item.is-selected {
  background-color: #eaeaea;
  color: #e60202;
}

/* .guide-img {
  height: 500px;
  width: 500px;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue